import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'lib-flexible'
import store from './store'
import VueLazyload from 'vue-lazyload'
import { Toast } from 'vant';
import { DatetimePicker } from 'vant';
import { Popup } from 'vant';
import vconosle from 'vconsole'
import 'vant/lib/index.css'
Vue.use(Toast);
Vue.use(DatetimePicker);
Vue.use(Popup);
// if(process.env.NODE_ENV !== 'production'){
  // new vconosle()
// }


Vue.use(VueLazyload, {
    //  loading: require('img/loading.png'),//加载中图片，一定要有，不然会一直重复加载占位图
    //  error: require('img/error.png')  //加载失败图片
});
//新湖南云判断
var UA = window.navigator.userAgent;
var isAndroid = UA.indexOf('Android') > 0;
var isIOS = /iPhone|iPad|iPod|iOS/.test(UA);
var isXinhunan = false;
if (isAndroid || isIOS) {
  //确定是在安卓,苹果手机中再判断是否在新湖南(ios 12 UA会写入失败，这里忽略)
  if(UA.substring(0, 4) === "xhn-" || UA.startsWith("Mozilla/5.0 (iPhone; CPU iPhone OS 12"))
  {
    isXinhunan = true;
  }	
}
Vue.prototype.isXinhunan = isXinhunan;
Vue.prototype.$matomo = window.Piwik.getAsyncTracker()
Vue.prototype.$matomo.setSiteId(9);
//新湖南云判断结束
Vue.config.productionTip = false
document.title = process.env.VUE_APP_PAPERTITLE
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
